import React from 'react';
import { Link } from 'react-scroll';
import { FaTelegramPlane, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo.jpg" alt="OSTONA" />
              <span>OSTONA</span>
            </div>
            <p>
              Zamonaviy kvartira qidirish platformasi. Qurilish kompaniyalari bilan
              to'g'ridan-to'g'ri bog'laning, 3D ko'ring va onlayn shartnoma tuzing.
            </p>
            <div className="footer-socials">
              <a href="https://t.me/ostona" target="_blank" rel="noopener noreferrer" className="footer-social">
                <FaTelegramPlane />
              </a>
              <a href="https://instagram.com/ostona" target="_blank" rel="noopener noreferrer" className="footer-social">
                <FaInstagram />
              </a>
              <a href="https://facebook.com/ostona" target="_blank" rel="noopener noreferrer" className="footer-social">
                <FaFacebookF />
              </a>
              <a href="https://youtube.com/ostona" target="_blank" rel="noopener noreferrer" className="footer-social">
                <FaYoutube />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Platforma</h4>
            <Link to="features" smooth duration={600} offset={-70}>Imkoniyatlar</Link>
            <Link to="how-it-works" smooth duration={600} offset={-70}>Qanday ishlaydi</Link>
            <Link to="builders" smooth duration={600} offset={-70}>Quruvchilar</Link>
            <Link to="download" smooth duration={600} offset={-70}>Yuklab olish</Link>
          </div>

          <div className="footer-col">
            <h4>Aloqa</h4>
            <a href="mailto:info@ostona.uz">info@ostona.uz</a>
            <span style={{ color: 'rgba(255,255,255,0.6)' }}>Toshkent, O'zbekiston</span>
          </div>
        </div>

        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} OSTONA. Barcha huquqlar himoyalangan.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
